import { 
    UPDATE_CV_EDUCATIONS,
    UPDATE_CV_EDUCATIONS_ERROR,
    UPDATE_CV_EDUCATIONS_SUCCESS
} from '../../store/constants';

const initalState = {
    error: false,
    loading: false,
    success: false,
}

const reducer = (state = initalState, action) => {
    switch (action.type) {
        case UPDATE_CV_EDUCATIONS:
            return {...state, loading: true, error: false, success: false };
        case UPDATE_CV_EDUCATIONS_SUCCESS:
            return {...state, loading: false, success: true };
        case UPDATE_CV_EDUCATIONS_ERROR: 
            return {...state, loading: false, error: true };
        default: 
            return state;
    }
}

export default reducer;